import * as React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 15h-2.583a8.172 8.172 0 0 1-3.417.75A8.17 8.17 0 0 1 8.583 15H6a6 6 0 0 0-6 6v.75A2.25 2.25 0 0 0 2.25 24h19.5A2.25 2.25 0 0 0 24 21.75V21a6 6 0 0 0-6-6zm-6-1.5a6.752 6.752 0 0 0 6.75-6.75A6.752 6.752 0 0 0 12 0a6.752 6.752 0 0 0-6.75 6.75A6.752 6.752 0 0 0 12 13.5z"
      fill="#9dc8d2"
      fillRule="evenodd"
      opacity=".5"
    />
  </svg>,
  "User"
);
